
import Blank from "@/layouts/blank.vue"

import AssetVehicleAvailabilityDashboardRoutes from "@/router/admin/assetAvailability/vehicleAvailability"


const assetAvailabilityDashboardRoutes = [
  {
    path: "assets_availability_dashboard",
    name: "app-admin-asset-availability",
    component: Blank,
    children: [
      ...AssetVehicleAvailabilityDashboardRoutes,

    ]
  },
]

export default assetAvailabilityDashboardRoutes